import * as React from "react";

const IconVK = (props) => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z"
      className="bg-circle"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.046 26.564s.385-.043.582-.25c.18-.19.174-.55.174-.55s-.024-1.68.77-1.927c.783-.244 1.788 1.623 2.854 2.341.806.543 1.417.424 1.417.424l2.85-.038s1.49-.09.783-1.24c-.058-.095-.412-.852-2.118-2.407-1.787-1.627-1.547-1.364.604-4.18 1.31-1.714 1.835-2.76 1.67-3.208-.155-.428-1.119-.315-1.119-.315l-3.207.02s-.238-.032-.415.071c-.172.102-.283.338-.283.338s-.507 1.327-1.185 2.455c-1.428 2.38-1.999 2.507-2.232 2.36-.544-.346-.409-1.386-.409-2.124 0-2.308.357-3.27-.693-3.518-.349-.083-.605-.138-1.498-.147-1.144-.011-2.113.004-2.661.268-.366.175-.647.566-.475.589.212.027.692.127.946.467.329.439.317 1.424.317 1.424s.19 2.716-.44 3.053c-.433.232-1.026-.24-2.3-2.4a19.926 19.926 0 01-1.144-2.33s-.095-.228-.265-.35c-.206-.15-.493-.195-.493-.195l-3.048.02s-.458.011-.626.207c-.149.173-.011.533-.011.533s2.386 5.48 5.089 8.243c2.478 2.531 5.29 2.366 5.29 2.366h1.276z"
      fill="#fff"
    />
  </svg>
)

export default IconVK;